import { createValueStorage } from '@bos/utils';
import { tokenWithExpirationSchema } from './tokenWithExpiration';
export const createTokenStorage = (serviceName) => {
    const accessTokenKey = `${serviceName}-accessToken`;
    const accessTokenStorage = createValueStorage(accessTokenKey, tokenWithExpirationSchema);
    const refreshTokenKey = `${serviceName}-refreshToken`;
    const refreshTokenStorage = createValueStorage(refreshTokenKey, tokenWithExpirationSchema);
    return {
        serviceName,
        accessToken: accessTokenStorage,
        refreshToken: refreshTokenStorage,
        clear: () => {
            accessTokenStorage.remove();
            refreshTokenStorage.remove();
        },
    };
};
